import {
    createSlice
} from "@reduxjs/toolkit";

import {
    feedStatus
} from "../../utils/constant";
import {
    deactivateUser,
    getMembersExportList,
    getMembersList,
} from "../../services/members";

const initialState = {
    mentor: [],
    mentee: [],
    exportData: [],
    loading: false,
    status: "",
    error: "",
};

export const memberSlice = createSlice({
    name: "members",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMembersList.pending, (state) => {
                return {
                    ...state,
                    loading: true,
                };
            })
            .addCase(getMembersList.fulfilled, (state, action) => {
                let {
                    role,
                    data
                } = action.payload
                return {
                    ...state,
                    [role]: data,
                    status: feedStatus.load,
                    loading: false,
                    error: ''
                };
            })
            .addCase(getMembersList.rejected, (state, action) => {
                return {
                    ...state,
                    loading: false,
                    error: action.error.message,
                };
            });
        
        builder
            .addCase(getMembersExportList.pending, (state) => {
                return {
                    ...state,
                    loading: true,
                };
            })
            .addCase(getMembersExportList.fulfilled, (state, action) => {
                let {
                   
                    data
                } = action.payload
                return {
                    ...state,
                    exportData: data,
                    status: feedStatus.load,
                    loading: false,
                    error: ''
                };
            })
            .addCase(getMembersExportList.rejected, (state, action) => {
                return {
                    ...state,
                    loading: false,
                    error: action.error.message,
                };
            });
        builder
            .addCase(deactivateUser.pending, (state) => {
                return {
                    ...state,
                    loading: true,
                };
            })
            .addCase(deactivateUser.fulfilled, (state, action) => {
                return {
                    status: '',
                    loading: false,
                    error: ''
                };
            })
            .addCase(deactivateUser.rejected, (state, action) => {
                return {
                    ...state,
                    loading: false,
                    error: action.error.message,
                };
            });


    },
});

export default memberSlice.reducer;